import React from 'react';

import { Skeleton } from '@mint-lib/tw-components';

export const ChatListSkeleton = () => {
  const skeletonCards = Array.from({ length: 12 }).map((_, index) => ({
    id: index + 1,
  }));

  return (
    <div className="flex h-full w-full flex-col">
      <div className="flex flex-col gap-2">
        {skeletonCards.map((s) => (
          <Skeleton key={s.id} variant="rounded" className="h-8 w-67.5" />
        ))}
      </div>
    </div>
  );
};
